import YGCClassPage from "./YGCClassPage";
export default function Ygc2027() {
  return <YGCClassPage year="2027" wip={true} />;
}